/* ==========================================================================
   MG GLOBAL JS
   - Mobile menu toggle (mg-header)
   - Scroll to top button (mg-footer)
   - Entrance animations ([data-mg-animate])
   ========================================================================== */
(function () {
  'use strict';

  function mgInitMenu() {
    document.querySelectorAll('[data-mg-header]').forEach(function (mgHeader) {
      if (mgHeader.dataset.mgMenuReady) return;
      mgHeader.dataset.mgMenuReady = 'true';

      var mgToggle = mgHeader.querySelector('[data-mg-menu-toggle]');
      if (!mgToggle) return;

      function mgSetOpen(mgOpen) {
        mgHeader.classList.toggle('mg-menu-open', mgOpen);
        mgToggle.setAttribute('aria-expanded', mgOpen ? 'true' : 'false');
      }

      mgToggle.addEventListener('click', function () {
        mgSetOpen(mgToggle.getAttribute('aria-expanded') !== 'true');
      });

      document.addEventListener('keydown', function (mgEvent) {
        if (mgEvent.key === 'Escape') mgSetOpen(false);
      });

      document.addEventListener('click', function (mgEvent) {
        if (!mgHeader.contains(mgEvent.target)) mgSetOpen(false);
      });
    });
  }

  function mgInitToTop() {
    var mgBtn = document.querySelector('[data-mg-to-top]');
    if (!mgBtn || mgBtn.dataset.mgReady) return;
    mgBtn.dataset.mgReady = 'true';

    var mgTicking = false;
    function mgUpdate() {
      mgBtn.classList.toggle('mg-is-visible', window.scrollY > window.innerHeight * 0.5);
      mgTicking = false;
    }

    window.addEventListener('scroll', function () {
      if (!mgTicking) {
        window.requestAnimationFrame(mgUpdate);
        mgTicking = true;
      }
    }, { passive: true });

    mgBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    mgUpdate();
  }

  var mgAnimObserver = null;

  function mgInitAnimations(mgRoot) {
    var mgEls = (mgRoot || document).querySelectorAll('[data-mg-animate]:not(.mg-animated)');
    if (!mgEls.length) return;

    if (!('IntersectionObserver' in window)) {
      mgEls.forEach(function (mgEl) { mgEl.classList.add('mg-animated'); });
      return;
    }

    if (!mgAnimObserver) {
      mgAnimObserver = new IntersectionObserver(function (mgEntries) {
        mgEntries.forEach(function (mgEntry) {
          if (mgEntry.isIntersecting) {
            mgEntry.target.classList.add('mg-animated');
            mgAnimObserver.unobserve(mgEntry.target);
          }
        });
      }, { threshold: 0.15 });
    }

    mgEls.forEach(function (mgEl) { mgAnimObserver.observe(mgEl); });
  }

  // Animated <details data-mg-acc>: 400ms slide, like the WordPress accordions.
  // "One open at a time" inside [data-mg-acc-single] or [data-mg-faq-single].
  function mgInitAccordions() {
    document.querySelectorAll('details[data-mg-acc]').forEach(function (mgD) {
      if (mgD.dataset.mgAccReady) return;
      mgD.dataset.mgAccReady = 'true';
      var mgSum = mgD.querySelector('summary');
      var mgBody = mgD.querySelector('summary + *');
      if (!mgSum || !mgBody) return;

      function mgClose(mgItem) {
        var mgB = mgItem.querySelector('summary + *');
        if (!mgItem.open || !mgB) return;
        mgB.style.height = mgB.scrollHeight + 'px';
        void mgB.offsetHeight;
        mgB.style.transition = 'height 0.4s ease';
        mgB.style.height = '0px';
        mgItem.classList.add('mg-is-closing');
        setTimeout(function () {
          mgItem.open = false;
          mgItem.classList.remove('mg-is-closing');
          mgB.style.height = '';
          mgB.style.transition = '';
        }, 400);
      }

      mgSum.addEventListener('click', function (mgE) {
        mgE.preventDefault();
        if (mgD.open) { mgClose(mgD); return; }
        var mgGroup = mgD.closest('[data-mg-acc-single], [data-mg-faq-single]');
        if (mgGroup) {
          mgGroup.querySelectorAll('details[data-mg-acc][open]').forEach(function (mgO) {
            if (mgO !== mgD) mgClose(mgO);
          });
        }
        mgD.open = true;
        var mgH = mgBody.scrollHeight;
        mgBody.style.height = '0px';
        void mgBody.offsetHeight;
        mgBody.style.transition = 'height 0.4s ease';
        mgBody.style.height = mgH + 'px';
        setTimeout(function () {
          mgBody.style.height = '';
          mgBody.style.transition = '';
        }, 400);
      });
    });
  }

  // FAQ: only one question open at a time
  function mgInitFaq() {
    document.querySelectorAll('[data-mg-faq-single]').forEach(function (mgRoot) {
      if (mgRoot.dataset.mgFaqReady) return;
      mgRoot.dataset.mgFaqReady = 'true';
      mgRoot.addEventListener('toggle', function (mgE) {
        if (!mgE.target.open) return;
        mgRoot.querySelectorAll('details[open]').forEach(function (mgD) {
          if (mgD !== mgE.target) mgD.open = false;
        });
      }, true);
    });
  }

  // Reviews: reveal the next page of reviews
  function mgInitReviews() {
    document.querySelectorAll('[data-mg-reviews-more]').forEach(function (mgBtn) {
      if (mgBtn.dataset.mgReady) return;
      mgBtn.dataset.mgReady = 'true';
      var mgSection = mgBtn.closest('.mg-reviews');
      var mgList = mgSection.querySelector('[data-mg-reviews]');
      var mgPer = parseInt(mgList.dataset.mgPer, 10) || 5;
      mgBtn.addEventListener('click', function () {
        var mgHidden = mgList.querySelectorAll('.mg-is-hidden');
        for (var mgI = 0; mgI < Math.min(mgPer, mgHidden.length); mgI++) mgHidden[mgI].classList.remove('mg-is-hidden');
        var mgLeft = mgList.querySelectorAll('.mg-is-hidden').length;
        if (!mgLeft) { mgBtn.parentElement.remove(); return; }
        mgBtn.textContent = mgBtn.dataset.mgLabel.replace('[count]', mgLeft);
      });
    });
  }

  function mgInit() {
    mgInitReviews();
    mgInitMenu();
    mgInitToTop();
    mgInitAnimations();
    mgInitFaq();
    mgInitAccordions();
  }

  window.mgInitAnimations = mgInitAnimations;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mgInit);
  } else {
    mgInit();
  }

  // Re-init when sections are edited in the theme editor
  document.addEventListener('shopify:section:load', mgInit);
})();
